import { useSelector } from "../store";

export default function usePractitioner() {
  return useSelector((state) => state.user.practitionerReference);
}

export const usePractitionerReference = usePractitioner;
